import moment from "moment";
import { WaitlistUpdateRequestStatus as Status,
  WaitlistUpdateMetadata_interestList_scheduledUpdate as scheduledUpdate,
  RequestedCounts_interestList_scheduledUpdate_requestedCounts as RequestedCounts } from "types/gql-types";

export const timeUntil = (time: moment.Moment): number => Math.max(0, time.diff(moment()));

export const isBeforeDeadline = (time: moment.Moment): boolean => timeUntil(time) > 0;

export const isUpdateActive = (update:scheduledUpdate): boolean => update.enabled;

export const countByRequestedCountStatus = (
  requested: RequestedCounts[],
  status: Status[],
) : number =>
  requested.reduce((count, { status: rStatus, totalCount: rCount }) => {
    if (status.includes(rStatus)) {
      return count + rCount;
    }
    return count;
  }, 0);
